import { setJwtToken } from '@/helpers/setRequestHeaders'
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'

export type FeedingType = {
    id: number
    title: string
    value: string
}

type FeedingTypeDto = {
    title: string
    value: string
}

export const feedingTypesApi = createApi({
    reducerPath: 'feedingTypesApi',
    baseQuery: fetchBaseQuery({
        baseUrl: process.env.NEXT_PUBLIC_API_ENDPOINT || 'http://megakorm.ru:3005/api',
        prepareHeaders: setJwtToken
    }),
    tagTypes: ["FEEDING-TYPE"],
    endpoints: builder => ({
        getAllFeedingTypes: builder.query<FeedingType[], void>({
            query: () => ({ url: `/feeding-type` }),
            providesTags: ["FEEDING-TYPE"],
        }),
        getAllFeedingTypesEn: builder.query<FeedingType[], void>({
            query: () => ({ url: `/feeding-type?lang=en` }),
            providesTags: ["FEEDING-TYPE"],
        }),
        getFeedingType: builder.query<FeedingType, { id: number }>({
            query: ({ id }) => ({ url: `/feeding-type/${id}` }),
            providesTags: ["FEEDING-TYPE"],
        }),
        createFeedingType: builder.mutation<any, FeedingTypeDto>({
            query: (body) =>({url: `/feeding-type`, method: "POST", body: body}),
            invalidatesTags: ["FEEDING-TYPE"],
        }),
        deleteFeedingTypesByIds: builder.mutation<any, any>({
            query: (data)=> ({url: `/feeding-type/delete-by-ids/del`, method: "POST", body: data}),
            invalidatesTags: ["FEEDING-TYPE"],
        }),
        updateFeedingTypes: builder.mutation<any, any>({
            query: data => ({ url: `/feeding-type/${data.id}`, method: 'PATCH', body: data }),
            invalidatesTags: ["FEEDING-TYPE"],
        }),
        updateFeedingTypesEn: builder.mutation<any, any>({
            query: data => ({
                url: `/feeding-type/en/update/${data.id}`,
                method: 'PATCH',
                body: { title: data.title }
            }),
            invalidatesTags: ['FEEDING-TYPE']
        })
    })
})

export const { useGetAllFeedingTypesQuery, useGetAllFeedingTypesEnQuery, useGetFeedingTypeQuery, useCreateFeedingTypeMutation, useDeleteFeedingTypesByIdsMutation, useUpdateFeedingTypesMutation, useUpdateFeedingTypesEnMutation } = feedingTypesApi
